import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/user.service';
import { User } from '../shared/user.model';
import { AngularFireList } from '../../../../node_modules/angularfire2/database';
import { Subject } from '../../../../node_modules/rxjs';


@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  userList:User[];
  startAt :string;
  endAt :string;

  constructor(private userService:UserService) { }

  ngOnInit() {
    
  }

  search($event){
    let q=$event.target.value;
    this.startAt=q;
    this.endAt=q+"\uf8ff";
    this.loadUsers(this.userService.getData(this.startAt,this.endAt));
  }

  // loadUsers(list:AngularFireList<any>){
  //   this.userList = [];
  //   list.snapshotChanges().forEach(item => {
  //     Object.keys(item).map(key=>item[key]).map(user => {
  //       this.userList.push(user as User);
  //     })
  //   });
  // }
  
  // loadUsers(list:AngularFireList<any>){
  //   list.snapshotChanges().subscribe(item=>{
  //     this.userList = [];
  //     item.forEach(element => {
  //       var y = element.payload.toJSON();
  //       y["$key"] = element.key;
  //       this.userList.push(y as User);
  //     });
  //   })
  // }

  loadUsers(list:AngularFireList<any>){
    this.userList = [];
    list.query.once("value").then(data=>data.forEach(element => {
        // var y = element.exportVal().toJSON();
        // y["$key"] = element.key;
        this.userList.push(element.val() as User);
    }));
  }

}
